<template>
  <v-container>
    <h2>ユーザー管理</h2>

    <v-spacer></v-spacer>
    <v-dialog v-model="dialog" max-width="500">
      <edit-user
        @closeDialog="closeDialog"
        @createItem="createItem"
        @updateItem="updateItem"
        :item="selectedItem"
        :action="action"
      />
    </v-dialog>
    <v-expansion-panel v-model="panel" expand style="margin: 10px 0px">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div class="title">表示条件</div>
        </template>
        <v-card>
          <v-card-text>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading"
                >フリーワード *</v-flex
              >
              <v-flex md4>
                <v-text-field v-model="search"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-layout row align-center>
      <v-flex md3>
        <v-btn @click="addItem"> <v-icon>add</v-icon>追加 </v-btn>
      </v-flex>
      <v-flex md3>
        <input type="file" @change="selectedFile" />
      </v-flex>
      <v-flex md3>
        <v-btn :disabled="file == null" @click="importFile">インポート</v-btn>
      </v-flex>
    </v-layout>
    <v-layout style="height: 500px; width: 100%">
      <div class="table-container scroll-bar">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-1"
          :search="search"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="{ sticky: true, 'column-fixed': header.text == '日' }"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">{{ props.item.staff_id }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.team_name }}</td>
              <td class="text-xs-left">{{ props.item.user_type }}</td>
              <td class="text-xs-left">{{ props.item.work_type }}</td>
              <td class="text-xs-left">
                {{ unixtimeToTime(props.item.predefined_time) }}
              </td>
              <td class="text-xs-left">
                {{ getUserStatus(props.item.status) }}
              </td>
              <td>
                <v-btn icon @click="editItem(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon @click="deleteItem(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-layout>
    <v-btn color="green" class="white--text" @click="scrollToTop">
      <v-icon color="white">arrow_upward</v-icon>トップへ戻る
    </v-btn>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import auth from "@/components/fireAuthInit";
import EditUser from "@/components/User/editUser.vue";
import { unixtimeToFormattedTime } from "@/utils/datetime.js";
import { mapMutations } from "vuex";
import XLSX from "xlsx";
export default {
  components: {
    EditUser,
  },
  data() {
    return {
      items: [],
      file: null,
      action: "add",
      dialog: false,
      selectedItem: {},
      search: "",
      panel: [true],
      newItem: {
        id: "",
        name: "",
        email: "",
        first_password: "",
        staff_id: "",
        status: "有効",
        team_name: "",
        user_type: "スタッフ",
        work_type: "一般",
        predefined_time: 8 * 60 * 60,
        base_salary: 0,
        commuting_allowance: 0,
        kenko_insurance: 0,
        kouseinenkin_insurance: 0,
        hourly_base_salary: 0,
        max_home_work_days: 0,
      },
      headers: [
        {
          text: "社員番号 *",
          align: "left",
          sortable: false,
          value: "staff_id",
        },
        {
          text: "名前 *",
          align: "left",
          sortable: false,
          value: "name",
        },

        {
          text: "チーム *",
          align: "left",
          sortable: false,
          value: "team_name",
        },
        {
          text: "ユーザー種別 *",
          align: "left",
          sortable: false,
          value: "user_type",
        },

        {
          text: "勤務種別 *",
          align: "left",
          sortable: false,
          value: "work_type",
        },
        {
          text: "所定時間",
          align: "left",
          sortable: false,
          value: "predefined_time",
        },
        {
          text: "ステータス",
          align: "left",
          sortable: false,
          value: "status",
        },
        { text: "操作", sortable: false },
      ],
    };
  },
  mounted() {
    this.changeLoadingState(true);
    this.reloadItems();
    this.fixHeaders();
  },
  methods: {
    scrollToTop() {
      document.querySelector(".v-datatable tbody tr").scrollIntoView(false);
    },
    fixHeaders() {
      var elms = document.getElementsByClassName("v-table__overflow");
      elms[0].style.overflow = "visible";
    },
    async reloadItems() {
      this.items = [];
      const items = await db.collection("users").get();
      items.forEach((doc) => {
        this.items.push({ ...doc.data(), id: doc.id });
      });
      this.changeLoadingState(false);
    },
    getFormatDate(ut) {
      return unixtimeToFormattedDate(ut);
    },
    getUserStatus(status) {
      const userStatus = {
        creating: "作成中",
        enable: "有効",
        disable: "無効",
        failed: "失敗",
      };
      return userStatus[status];
    },
    closeDialog() {
      this.dialog = false;
    },
    async createItem(item) {
      this.changeLoadingState(true);
      this.closeDialog();
      item.status = "creating";
      await db.collection("users").add(item);
      this.reloadItems();
    },
    editItem(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.action = "update";
      this.dialog = true;
    },
    addItem() {
      this.selectedItem = JSON.parse(JSON.stringify(this.newItem));
      this.action = "add";
      this.dialog = true;
    },
    async deleteItem(item) {
      this.changeLoadingState(true);
      try {
        await db.collection("users").doc(item.id).delete();
        this.reloadItems();
      } catch (e) {
        console.log(e);
      }
    },
    async updateItem(item) {
      this.changeLoadingState(true);
      this.closeDialog();
      await db.collection("users").doc(item.id).set(item);
      this.reloadItems();
    },
    selectedFile(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    importFile() {
      const reader = new FileReader();
      reader.readAsArrayBuffer(this.file);
      reader.onload = (e) => {
        const data = new Uint8Array(reader.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const items = XLSX.utils.sheet_to_json(worksheet);
        this.createItems(items);
      };
    },
    async createItems(items) {
      this.changeLoadingState(true);
      const promises = [];
      try {
        items.forEach((item) => {
          item.status = "creating";
          const p = db.collection("users").add(item);
          promises.push(p);
        });
      } catch (e) {
        console.log(e);
      }
      await Promise.all(promises);
      this.reloadItems();
    },

    unixtimeToTime(unixtime) {
      return unixtimeToFormattedTime(unixtime);
    },
    ...mapMutations("app", ["changeLoadingState"]),
  },
  created: function () {},
};
</script>
<style lang="scss" scoped>
.v-datatable th.sticky {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;
}
.scroll-bar {
  overflow: auto;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background: gray;
}
.v-icon {
  margin-right: 0.3em;
}
</style>